<script>
import { componentStore } from "@common/componentStore/componentStore";
import icon from "@common/icon/Icon.vue";

const baseDropdownConfig = {
    cId: 'baseDropdown',
    cType: 'dropdown',
    cTitle: 'Base Dropdown',
    cTemplate: `<template>
    <div class="base-dropdown relative" ref="root">
<!--    TODO: practice cherry pick  -->
        <!-- Trigger -->
        <button
                @click="toggleDropdown"
                class="base_dropdown__trigger flex align-center p-1"
                type="button"
                :disabled="disabled"
                :class="{ 'no-chevron': !showChevron }"
        >
            <slot name="trigger" :label="userStore.coordinator.CLIENT_USER_NAME">
                <span class="base_dropdown__label">
                {{ selectedLabel }}
              </span>
            </slot>
            <icon v-if="showChevron"
                   name="chevron-down"
                   :size="'base'"
                   class="chevron-icon"
                   :class="{ rotated: open }">
            </icon>
            <transition name="slide-down">
                <div v-if="open" class="dropdown-menu">
                    <slot name="menu"/>
                </div>
            </transition>
        </button>

        <!-- Menu -->
        <ul v-if="open"
            class="base_dropdown__menu list-none absolute"
            role="listbox"
            aria-expanded="true"
        >
            <li v-for="option in options" :key="option.value" role="option" class="base_dropdown__list-item">
                <hr v-if="option.dividerBefore" class="base_dropdown__menu-divider" />
                <button @click="select(option)" class="base_dropdown__option">
                    <span>{{ option.label }}</span>
                </button>
            </li>
        </ul>
    </div>
</template>`,
    controls: [],
    layoutDatamap: []
};

const baseDropdownCmp = {
    name: 'BaseDropdown',
    props: {
        options: { type: Array, required: true },
        modelValue: { default: null },
        showChevron: { type: Boolean, default: true }
    },
    data() {
        return {
            isOpen: false
        };
    },
    computed: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        }
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        handleOption(option) {
            this.$emit('update:modelValue', option.value);
            if (option.action) option.action();
            this.isOpen = false;
        },
        handleClickOutside(event) {
            if (!this.$refs.dropdown.contains(event.target)) {
                this.isOpen = false;
            }
        }
    },
    watch: {
        modelValue() {
            this.isOpen = false;
        }
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }
};

componentStore.initComponent(baseDropdownCmp, baseDropdownConfig);
export { baseDropdownConfig, baseDropdownCmp };
export default baseDropdownCmp;
</script>

<style scoped>
.base-dropdown {
    background-color: var(--color-surface);
    gap: var(--space-3);
    transition: background-color var(--transition-default), border-color var(--transition-default);
    color: var(--color-text);
    z-index: var(--z-base);
}
.base-dropdown:hover {
    border-color: var(--color-border);
}
.chevron-icon {
    transition: transform var(--transition-default);
    color: var(--color-accent);
    margin-left: var(--space-2);
}
.chevron-icon.rotated {
    transform: rotate(180deg);
}
.base_dropdown__menu {
    background-color: var(--color-surface);
    display: block;
    padding: var(--space-2);
    color: #495057;
    text-decoration: none;
    transition: background-color var(--transition-default);
    font-size: var(--text-base);
    top: calc(100% + var(--space-2));
    right: 0;
    border: var(--border-default);
    box-shadow: var(--shadow-md);
    min-width: 12.5rem; /* 200px */
    width: -webkit-fill-available;
    z-index: var(--z-sticky);
}
.base_dropdown__menu:has(.icon-only-trigger) .chevron-icon {
    display: none;
}
.base_dropdown__list-item:hover {
    background-color: var(--color-background);
    color: var(--color-primary-hover);
}
.base_dropdown__option {
    display: block;
    padding: var(--space-3) var(--space-4);
    color: var(--color-text);
    text-decoration: none;
    transition: background-color var(--transition-default);
    font-size: var(--text-base);
    text-align: left;
    width: max-content;
}
.base_dropdown__menu-divider {
    border: none;
    height: 1px;
    background-color: var(--color-border-light);
}
.no-chevron {
    gap: 0;
}

.slide-down-enter-active,
.slide-down-leave-active {
    transition:
            max-height 250ms ease,
            opacity 200ms ease;
    overflow: hidden;
}
.slide-down-enter-to,
.slide-down-leave-from {
    max-height: 500px; /* large enough to fit content */
    opacity: 1;
}
.slide-down-enter-from {
    max-height: 0;
    opacity: 0;
    transform: translateY(-4px);
}

.slide-down-enter-active {
    transition:
            max-height 250ms ease,
            opacity 200ms ease,
            transform 200ms ease;
}

.slide-down-enter-to {
    transform: translateY(0);
}
</style>
